// removed by extract-text-webpack-plugin
module.exports = {"root":"_29wDO","fieldset":"_1CaOG","choiceGroup":"_1E2El","choices":"C4guS","label":"qBfYa","error":"AbtIU"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Form/styles.css
// module id = 1264
// module chunks = 6 7 8 11 12 13